// Пакет 5a, п.28 «Контрольная группа в каждой кампании»: правила доли контроля — чистые функции без React и сети.
// Совпадают с Go (p5_holdout.go: p5CheckHoldout). Отдельный файл, чтобы model.ts мог подключить правило без
// цикла импортов с p5Model.ts.
import type { MarketingDraft } from "./types";

/** Контроль по умолчанию, минимум и максимум, % гостей (как p5HoldoutDefault/Min/Max в Go). */
export const HOLDOUT_DEFAULT = 10;
export const HOLDOUT_MIN = 5;
export const HOLDOUT_MAX = 30;
/** Доли, которые предлагает «Запустить готовый». Выключение — отдельной отметкой, не пунктом списка. */
export const HOLDOUT_OPTIONS = [5, 10, 20, 30] as const;

export const NO_CONTROL_WARNING =
  "Без контроля прирост не посчитать: мы увидим, сколько гостей заказало после сообщения, но не узнаем, сколько из них заказало бы и без него.";

type HoldoutFields = Pick<MarketingDraft, "holdoutPercent" | "noControlConfirmed">;

/**
 * Что не так с контрольной группой черновика; null — всё в порядке. Правило Go (p5CheckHoldout): от 5 до 30%,
 * либо 0% с отметкой «без контроля». Кампания, сохранённая до правила (1–4% или 0% без отметки), правится и
 * запускается как раньше, пока контроль не меняют, — для неё передают baseline (сохранённые значения).
 */
export function holdoutProblem(
  draft: HoldoutFields,
  baseline?: HoldoutFields | null,
): string | null {
  const percent = draft.holdoutPercent;
  if (!Number.isInteger(percent) || percent < 0 || percent > HOLDOUT_MAX)
    return `Контрольная группа — от ${HOLDOUT_MIN} до ${HOLDOUT_MAX}% гостей.`;
  if (
    baseline &&
    baseline.holdoutPercent === percent &&
    !!baseline.noControlConfirmed === !!draft.noControlConfirmed
  )
    return null;
  if (percent === 0 && draft.noControlConfirmed) return null;
  if (percent === 0)
    return "Контрольная группа выключена: без неё прирост не посчитать. Верните 10% или отметьте, что запускаете без контроля.";
  if (percent < HOLDOUT_MIN)
    return `Контрольная группа — не меньше ${HOLDOUT_MIN}% гостей: на меньшей выборке прирост не посчитать.`;
  return null;
}

/** Подпись пункта выбора доли контроля. */
export function holdoutOptionLabel(percent: number): string {
  return percent === HOLDOUT_DEFAULT
    ? `${percent}% гостей · рекомендуем`
    : `${percent}% гостей`;
}

/** Состояние «без контроля» для черновика: 0% и осознанная отметка. */
export function withoutControl(draft: HoldoutFields): boolean {
  return draft.holdoutPercent === 0;
}

